import { render, staticRenderFns } from "./AdminTabsLayers.vue?vue&type=template&id=72247efc&scoped=true&"
import script from "./AdminTabsLayers.vue?vue&type=script&lang=js&"
export * from "./AdminTabsLayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72247efc",
  null
  
)

export default component.exports